/** School-owned keys used for student module visibility (sidebar + route gates). */
export const SCHOOL_STUDENT_FEATURE_KEYS = [
  'ai_tutor',
  'communication_tutor',
  'scenario_based_convo',
  'grammar',
  'picture_talk',
  'story_studio',
] as const;

export type SchoolStudentFeatureKey = (typeof SCHOOL_STUDENT_FEATURE_KEYS)[number];

/** Keys that may appear in grade_feature_allocations.by_grade (includes learning platform). */
export const GRADE_ALLOCATABLE_FEATURE_KEYS = [
  'learning',
  ...SCHOOL_STUDENT_FEATURE_KEYS,
] as const;

export type GradeAllocatableFeatureKey = (typeof GRADE_ALLOCATABLE_FEATURE_KEYS)[number];

export interface MyFeatureAccessResponse {
  tenant_id: string;
  school_feature_access: Record<string, boolean>;
}
